<template>
	<div class="control">
		<div class="form-group">
			<select id="Sort-By-filter" class="form-control bs-select" v-on:change="updateFilters" v-model="value" ref="select">
				<option v-for="value in control" v-bind:value="value.Value" v-bind:key="value.Value">{{ value.Name }}</option>
			</select>
		</div>
	</div>
</template>

<script>
    import 'bootstrap';
    import 'bootstrap-select';
    import { mapState, mapActions, mapMutations } from 'vuex';
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';

	export default {
		props: ['control', 'defaultValue', 'specification', 'placeholderText'],
		data: function () {
			return {
				value: this.defaultValue,
            }
		},
        mounted: function () {
			if(!this.placeholderText){

				this.placeholderText = "Select a value:";
			} else {
				console.log('d1', this.placeholderText);
			}
            $(this.$el.querySelector('.bs-select')).selectpicker({ 
                mobile: true,
				noneSelectedText: this.placeholderText
            }, this.placeholderText);

			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
                    this.value = this.defaultValue;

                    this.$nextTick(function () {
                        $('.bs-select').selectpicker('refresh');
                    });
				}
            });
        },
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilters() {
				this.updateSpecification({ key: this.specification, value: this.value });
			},
		}
	}
</script>
